/* Dalen — inline variant picker on product cards.
   Replaces Dawn's "Choose options" modal with per-option <select>s + a single
   Add-to-cart button that's disabled until every option has a value and a
   matching, available variant exists. */
(function () {
  function formatPrice(cents) {
    if (typeof cents !== 'number') return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function init(form) {
    if (form.dataset.dalenInitialized) return;
    form.dataset.dalenInitialized = 'true';

    var selects = form.querySelectorAll('.dalen-card-form__select');
    var variantInput = form.querySelector('.dalen-card-form__variant-id');
    var submitBtn = form.querySelector('button[type="submit"]');
    var variantsJson = form.querySelector('.dalen-card-form__variants');
    var priceEl = form.querySelector('.dalen-card-form__price');
    var labelEl = submitBtn ? submitBtn.querySelector('span:first-child') : null;
    if (!selects.length || !variantInput || !submitBtn || !variantsJson || !labelEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    var defaultLabel = labelEl.textContent.trim();
    var originalPriceHTML = priceEl ? priceEl.innerHTML : '';

    // Card image — swapped to the selected variant's image on change.
    var cardWrapper = form.closest('.card-wrapper');
    var mainImg = cardWrapper ? cardWrapper.querySelector('.card__media img') : null;
    var originalImgSrc = mainImg ? mainImg.getAttribute('src') : null;
    var originalImgSrcset = mainImg ? mainImg.getAttribute('srcset') : null;
    var originalImgAlt = mainImg ? mainImg.getAttribute('alt') : null;

    function findVariant(selectedValues) {
      return variants.find(function (variant) {
        return variant.options.every(function (opt, idx) {
          return opt === selectedValues[idx];
        });
      });
    }

    // Best-matching variant for the currently-chosen options (ignores any
    // option left unset), so the image can update on a partial selection
    // (e.g. picking a colour before a size).
    function findVariantForImage(selectedValues) {
      return variants.find(function (variant) {
        return selectedValues.every(function (val, idx) {
          return val === '' || variant.options[idx] === val;
        });
      });
    }

    function sizedImageUrl(src, width) {
      if (!src) return src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    function setImage(variant) {
      if (!mainImg) return;
      if (variant && variant.featured_image && variant.featured_image.src) {
        mainImg.setAttribute('src', sizedImageUrl(variant.featured_image.src, 533));
        mainImg.setAttribute('srcset', '');
        if (variant.featured_image.alt) mainImg.setAttribute('alt', variant.featured_image.alt);
      } else if (originalImgSrc) {
        // No per-variant image → restore the product's default image.
        mainImg.setAttribute('src', originalImgSrc);
        if (originalImgSrcset) mainImg.setAttribute('srcset', originalImgSrcset);
        if (originalImgAlt != null) mainImg.setAttribute('alt', originalImgAlt);
      }
    }

    function setPrice(variant) {
      if (!priceEl) return;
      if (!variant) {
        priceEl.innerHTML = originalPriceHTML;
        return;
      }
      var current = formatPrice(variant.price);
      var compare = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatPrice(variant.compare_at_price)
        : null;
      // Update the visible price items inside the existing price markup so
      // Dawn's CSS classes (.price-item--regular, .price-item--sale, etc.) all
      // keep their styling.
      var regular = priceEl.querySelectorAll('.price-item--regular, .price-item--last');
      regular.forEach(function (el) { el.textContent = current; });
      var sale = priceEl.querySelectorAll('.price-item--sale');
      sale.forEach(function (el) { el.textContent = current; });
      if (compare) {
        var cmp = priceEl.querySelectorAll('.price-item--regular.price-item--regular');
        cmp.forEach(function (el) { el.textContent = compare; });
      }
      // Strip the "From " prefix that Dawn adds when a price range exists.
      // We now have an exact price, so the prefix is no longer accurate.
      priceEl.querySelectorAll('.price-item').forEach(function (el) {
        el.textContent = el.textContent.replace(/^\s*From\s+/i, '');
      });
    }

    function update() {
      var values = Array.from(selects).map(function (s) { return s.value; });
      var allChosen = values.every(function (v) { return v !== ''; });

      if (!allChosen) {
        variantInput.disabled = true;
        submitBtn.disabled = true;
        labelEl.textContent = defaultLabel;
        setPrice(null);
        return;
      }

      var match = findVariant(values);
      if (match && match.available) {
        variantInput.value = match.id;
        variantInput.disabled = false;
        submitBtn.disabled = false;
        labelEl.textContent = defaultLabel;
        setPrice(match);
      } else if (match) {
        variantInput.value = match.id;
        variantInput.disabled = true;
        submitBtn.disabled = true;
        labelEl.textContent = 'Sold out';
        setPrice(match);
      } else {
        variantInput.disabled = true;
        submitBtn.disabled = true;
        labelEl.textContent = 'Unavailable';
        setPrice(null);
      }
    }

    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        update();
        // Swap the card image to reflect the chosen option(s).
        setImage(findVariantForImage(Array.from(selects).map(function (x) { return x.value; })));
      });
    });
    // Initial pass sets price/availability but leaves the server-rendered
    // image alone (no image swap until the user actually changes an option).
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.dalen-card-form').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init for sections re-rendered by the theme editor or AJAX swaps
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
